/**
 * Membercard Module
 *
 */

angular
  .module('membercard', ['ngResource', 'settings', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.membercard.all(), {
        controller: 'MembercardCtrl',
        templateUrl: '/r/static/templates/membercard/list.html',
      })
      .when(CONFIG.url.membercard.create(), {
        controller: 'MembercardAddCtrl',
        templateUrl: '/r/static/templates/membercard/new.html',
      })
      .when(CONFIG.url.membercard.view(), {
        controller: 'MembercardEditCtrl',
        templateUrl: '/r/static/templates/membercard/single.html',
      })
  }])

  .factory('Membercard', ['$resource', function ($resource) {
    var Membercard = $resource(
      CONFIG.api('membercard'),
      {},
      {
        query: {method: 'GET', isArray: false},
        preview: {method: 'POST', params: {id: 'preview'}},
      },
    )
    return Membercard
  }])

/* Controllers */

angular
  .module('membercard')
  .controller('MembercardCtrl', ['$scope', '$location', '$compile', '$rootScope', 'Membercard', function ($scope, $location, $compile, $rootScope, Membercard) {
    if ($location.path() == CONFIG.url.membercard.all()) {
      $scope.utils.setPageTitle(_('membercard_sent_membercards'))
      $scope.utils.setPageID('membercards')
    }

    getMembercards()

    $scope.paginate = function (page) {
      $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
    }

    // NB: Almost duplicate in invoice.js / announcement.js
    if ($location.hash().match(/receipt-notify\?n=(\d+)/)) {
      $rootScope.notification = $compile(
        '<span>' +
          _('HTML_notification_mooney_membercard_sent_paid', {
            _n: RegExp.$1,
            url: CONFIG.url.log.receipts(),
          }) +
          '</span>',
      )($scope)
    }

    a4.loaded($scope)

    function getMembercards() {
      if ($location.path() === CONFIG.url.membercard.all()) {
        // list view
        Membercard.query(
          {id: 'all', dashboard: 'false'},
          // success handler
          function (data) {
            $scope.membercards = data.membercards
            $scope.stats = data.stats

            // pagination
            $scope.pageSize = 20
            $scope.numberOfPages = Math.ceil($scope.membercards.length / $scope.pageSize)
            $scope.currentPage = 0

            a4.loaded($scope)
          },
          // error handler
          a4.restErrorFactory($scope),
        )
      } else {
        // dashboard view
        Membercard.query(
          {id: 'all', dashboard: 'true'},
          // success handler
          function (data) {
            $scope.members_with_membercard = data.members_with_membercard
            $scope.members_total = data.members_total
            // $scope.members_with_phone_and_without_membercard = data.members_with_phone_and_without_membercard
            // $scope.members_without_phone = data.members_without_phone

            a4.loaded($scope)
          },
          // error handler
          a4.restErrorFactory($scope),
        )
      }
    }
  }])

angular.module('membercard').controller('MembercardAddCtrl', ['$scope', '$location', 'Membercard', 'Settings', function ($scope, $location, Membercard, Settings) {
  $scope.utils.setPageTitle(_('membercards_new_membercard_short'))
  $scope.utils.setPageID('membercards')

  $scope._sending = false
  $scope.previewing = false

  Settings.get({}, function (settings) {
    $scope.settings = settings
  })

  $scope.msg = new Membercard({
    subject: '',
    content: '',
    msg_media: 'sms',
  })

  // scroll to top so the user sees the help text
  window.scrollTo(0, 0)

  a4.loaded($scope)

  var condwatcher = $scope.$watch(
    'conditions+msg',
    function () {
      if ($scope.conditions.length > 0 && $scope.msg) {
        condwatcher() // unwatch
        $scope.conditions.push({
          id: 'default-mcstatus',
          field: 'membercardstatus',
          field_option: [$scope.msg.id],
          value: 'not_sent',
          verb: 'a4membercardstatus',
          locked: false,
          removeLocked: false,
          fieldLocked: false,
        })
      }
    },
    true,
  )

  $scope.proceed_to_payment = function () {
    var _self = this

    $scope.msg.filter = $scope.filter_to_post

    $scope._sending = true

    Membercard.save(
      {},
      $scope.msg,
      // success handler
      function (data) {
        _self.membercard_form.$dirty = false
        $location.path(CONFIG.url.mooney.method(data['mid'])).search('goto', CONFIG.get('urls.membercard.all'))
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }

  $scope.msgModel = function () {
    return 'membercard'
  }

  $scope.preview = a4.msgPreview($scope, Membercard)
  $scope.cancelPreview = a4.msgPreviewCancel($scope)
}])

angular.module('membercard').controller('MembercardEditCtrl', ['$scope', '$routeParams', 'Membercard', function ($scope, $routeParams, Membercard) {
  $scope.viewStatus = ''
  $scope.utils.setPageID('membercards')

  getMembercard()

  function getMembercard() {
    Membercard.get(
      {id: $routeParams.id},
      // success handler
      function (data) {
        $scope.msg = data
        a4.loaded($scope)
      },
      a4.restErrorFactory($scope),
    )
  }
}])
